import { buildMeta } from "../../routeMeta";

export { default } from "../../../src/pages/faq/index";

export function meta(args) {
  return buildMeta(
    {
      title: "FAQ — The Atlas of Economic Complexity",
      description:
        "Frequently asked questions about Atlas data, methodology, and visualizations.",
    },
    args,
  );
}
